import React, { useState } from 'react';
import './Policy.css';
// Import the background image
import bannerBackground from '../../assets/background.jpg';

const Policy: React.FC = () => {
  const [activeSection, setActiveSection] = useState<string>("請假須知");
  const [activeMobileSection, setActiveMobileSection] = useState<string | null>(null);

  // Policy sections data
  const policySections = [
    {
      id: "請假須知",
      title: "請假須知",
      content: (
        <div className="policy-content">
          <ul className="policy-numbered-list">
            <li>事假：如需更改課堂日子，請於24小時前通知，否則當缺席處理，不設另外補堂</li>
            <li>病假：學生須於課堂前最少2小時通知，並於復課時補回醫生證明</li>
            <li>除病假外，不接受即日請假。</li>
            <li>如成功通知請假後，學生可以與導師重新預約下次課堂日期。</li>
            <li>無故缺席課堂均視作曠課論，恕不安排補課或退款。</li>
          </ul>
        </div>
      )
    },
    {
      id: "惡劣天氣安排",
      title: "惡劣天氣安排",
      content: (
        <div className="policy-content">
          <ul className="policy-numbered-list">
            <li>「三號或以下熱帶氣旋警告信號」及/或「紅色或以下暴雨警告信號」懸掛時照常上課。</li>
            <li>如果雨勢過大，經導師商討後有機會取消並順延當日課堂。</li>
            <li>如天文台於課堂開始前兩小時內懸掛「八號或以上熱帶氣旋警告信號」及/或「黑色暴雨警告信號」，或預警將於課堂期間懸掛上述惡劣天氣警告，相關課堂將會順延，學生請留在安全地方。</li>
            <li>除個別通知外，如上述惡劣天氣警告於課堂前兩小時除下，所有課堂將如常進行。</li>
          </ul>
        </div>
      )
    },
    {
      id: "試堂須知",
      title: "試堂須知",
      content: (
        <div className="policy-content">
          <ul className="policy-numbered-list">
            <li>於預約及完成付款確認試玩日子後，最多只能改期一次(生病除外)。如果改期後仍未能出席則不設退款，學員需要再次支付試堂費用。</li>
          </ul>
        </div>
      )
    },
    {
      id: "課堂守則",
      title: "課堂守則",
      content: (
        <div className="policy-content">
          <ol className="policy-numbered-list">
            <li>在課堂之前及進行時，學員需遵守 JSW 的指引及指示。</li>
            <li>JSW Studio設有儲物櫃，學員應自行負責攜來之財物的安全。如於活動前後或中途有任何損傷失竊，JSW或任何相關教練恕不負責。</li>
            <li>如因學員疏忽而導致活動中任何設備、器具、裝置或其他財物遭到損壞或損毀（正常損耗除外）、偷竊或被移走，學員須支付修理、修復或重新購置有關物品的費用。</li>
            <li>JSW 可能在課堂中拍照或錄像拍攝作記錄及宣傳用途，如不希望入鏡，請及早通知JSW教練。</li>
          </ol>
        </div>
      )
    },
    {
      id: "退款政策",
      title: "退款政策",
      content: (
        <div className="policy-content">
          <ul className="policy-numbered-list">
            <li>JSW 不設任何原因之退款，未能成班之課堂將會安排改期。如因惡劣天氣或其他不可抗力因素而取消的課堂同樣會作延期處理。</li>
          </ul>
        </div>
      )
    }
  ];

  const handleSectionClick = (sectionId: string) => {
    setActiveSection(sectionId);
  };

  const toggleMobileSection = (sectionId: string) => {
    setActiveMobileSection(activeMobileSection === sectionId ? null : sectionId);
  };

  const getActiveContent = () => {
    const activePolicy = policySections.find(section => section.id === activeSection);
    return activePolicy ? activePolicy.content : null;
  };

  return (
    <section id="policy" className="policy-page section">
      <div className="full-width-banner" style={{ backgroundImage: `url(${bannerBackground})` }}>
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h2 className="banner-title" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700, fontSize: '2.5rem' }}>課堂政策</h2>
        </div>
      </div>
      
      <div className="policy-container">
        <div className="policy-intro">
          <ul className="policy-point-list">
            <li>學員參加 Jay Street Workout & Calisthenics Studio（下簡稱為「JSW」 ）的課堂即表示其明白及同意所有課堂政策。</li>
            <li>JSW 保留更改課堂政策細節的權利。</li>
            <li>如有任何爭議，JSW 保留最終決定權。</li>
          </ul>
        </div>
        
        {/* Desktop View - Original Two-Column Layout */}
        <div className="policy-layout desktop-view">
          <div className="policy-nav">
            {policySections.map((section) => (
              <div 
                key={section.id}
                className={`policy-nav-item ${activeSection === section.id ? 'active' : ''}`}
                onClick={() => handleSectionClick(section.id)}
              >
                <h3>{section.title}</h3>
                <span className="policy-nav-icon">+</span>
              </div>
            ))}
          </div>
          
          <div className="policy-content-panel">
            {getActiveContent()}
          </div>
        </div>
        
        {/* Mobile View - Accordion Layout */}
        <div className="policy-sections mobile-view">
          {policySections.map((section) => (
            <div key={section.id} className="policy-section-container">
              <div 
                className={`policy-section-header ${activeMobileSection === section.id ? 'active' : ''}`}
                onClick={() => toggleMobileSection(section.id)}
              >
                <h3>{section.title}</h3>
                <span className="policy-nav-icon">{activeMobileSection === section.id ? '-' : '+'}</span>
              </div>
              {activeMobileSection === section.id && (
                <div className="policy-section-content">
                  {section.content}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Policy;
